/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { Card, CardContent, Typography, Grid, Chip, Box, useMediaQuery, CircularProgress } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { Formater, LocalStorage, TypeRecords } from "src/framework/commons";
import { FullWidthButton } from "src/framework/components/buttons";
import { TProduto, TSelo } from "./types";
import "./styles.scss";
import { Selo } from "../Selo";
import { TCarrinho, TCarrinhoItem } from "../Carrinho/types";
import { resolveUploadUrl } from "src/store/global.store";
import { TiposEstruturas } from "src/types";
import theme from "src/theme/light";
import { CarrinhoStore } from "../Carrinho/store";

interface IProduto {
    data: TProduto,
    classes: any
    onDetalhesClick?: (produto: TProduto) => void;
    onAdd?: (produto: TCarrinhoItem) => void;
    adicaoDesabilitada: boolean;
    nomeMinHeight?: number;
    tagsMinHeight?: number;
    onNomeMinHeightChange?: () => void;
    onTagsMinHeightChange?: () => void;
    estruturas: TiposEstruturas[] | null;
}

const Produto: FC<IProduto> = ({ data, classes, onDetalhesClick, onAdd, adicaoDesabilitada, nomeMinHeight, tagsMinHeight, onNomeMinHeightChange, onTagsMinHeightChange, estruturas}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const selosCache = LocalStorage.get("solar.selos", true) || []; 
    const uploadUrl = resolveUploadUrl(LocalStorage.get("solar.uploads", true) || null) || ""

    const elementNome = useRef<any>();
    const elementTags = useRef<any>();

    const [atualOffsetTags, setatualOffsetTags] = useState<number>(1);
    const [atualOffsetNome, setAtualOffsetNome] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        function updateSize() {
            setatualOffsetTags(elementTags?.current?.offsetHeight);
            setAtualOffsetNome(elementNome?.current?.offsetHeight);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    useEffect(() => {
        data.heightNome = elementNome?.current?.offsetHeight;
        if (onNomeMinHeightChange) {
            onNomeMinHeightChange();
        }
    }, [atualOffsetNome])

    useEffect(() => {
        data.heightTags = elementTags?.current?.offsetHeight;
        if (onTagsMinHeightChange) {
            onTagsMinHeightChange();
        }
    }, [atualOffsetTags])

    if (!data?.preco || !Number(data?.preco)) return <></>;
    
    return <Card className={`CardProduto ${classes.CardProduto}`}>
        <Box className="selos-container">
            {data?.selos?.map((_selo: TSelo, index: number) => {
                const selo = selosCache?.data?.find((seloCache: any) => seloCache?.id === _selo?.selo_id);
                if (selo) {
                    return <Selo 
                        key={`card-selo-${index}`}
                        label={selo?.codigo_integracao}
                        title={selo?.nome}
                    />
                }
                
                return "";
            })}
        </Box>
        {uploadUrl && <img
            className={classes.itemImage}
            src={`//${uploadUrl}${data.imagem}`}
        />}
        <CardContent>
            <div style={{minHeight: tagsMinHeight || 0}}>
            <div ref={elementTags}>
                <Chip
                    className="tags"
                    color="secondary"
                    label={data.segmento === "on" ? "On Grid" : "Off Grid"}

                />
                <Chip
                    className="tags"
                    color="secondary"
                    label={estruturas?.find((item: any) => item.id === data.tipo_estrutura_id)?.nome}

                />
                <Chip
                    className="tags"
                    color="secondary"
                    label={data.potencia + " kWp"}

                />
            </div>
            </div>
            <div className="nome" style={{minHeight: nomeMinHeight}} >
                <p ref={elementNome}>
                    <strong>{data.nome}</strong>
                </p>
            </div>

            <Typography variant="body2" color="textSecondary" component="p">
                A partir de:
            </Typography>
            <Typography variant="h5" color="primary" component="p">
                <strong>{Formater.toString(data.preco, TypeRecords.CURRENCY)}</strong>
            </Typography>
        </CardContent>
        <Grid size={12} spacing={1}
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
        >
            <Grid size={12} style={ isMobile ? { width: "100%" } : {}}>
                <FullWidthButton
                    variant="contained"
                    color="primary"
                    text="Adicionar ao carrinho"
                    disabled={adicaoDesabilitada  || loading}
                    fullWidth={isMobile}
                    startIcon={loading ? <CircularProgress size="15px" /> : undefined}
                    onClick={async () => {
                        setLoading(true);
                        if (data) {
                            const item: TCarrinhoItem = { 
                                id: Number(data.id),
                                quantidade: 1,
                                produto: data
                            };

                            const carrinho: TCarrinho | null = CarrinhoStore.getCarrinho();
                            const find: TCarrinhoItem | undefined = carrinho?.itens?.find(i => i?.produto?.id === Number(data.id));

                            const quantidadeAtual = find?.quantidade || 0;
                            item.quantidade = quantidadeAtual + 1;
                            if (CarrinhoStore.validaQuantidadeMaxima(item)) {
                                item.quantidade = 1;
                                if (onAdd) { 
                                    await onAdd(item);
                                }
                            } else {
                                item.quantidade = quantidadeAtual;
                            }
                        }
                        setTimeout(() => { setLoading(false) }, 700);
                    }}
                />
            </Grid>
            <Grid size={12} style={ isMobile ? { width: "100%" } : {}}>
                <FullWidthButton
                    variant="outlined"
                    color="secondary"
                    text="Detalhes"
                    fullWidth={isMobile}
                    onClick={() => { onDetalhesClick && onDetalhesClick(data) }}
                />
            </Grid>
        </Grid>
    </Card>
}

export { Produto }